import initial from '../data/reviews';

const STORAGE_KEY = 'gr_reviews_v1';

function loadStorage() {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(initial));
    return initial.slice();
  }
  try {
    return JSON.parse(raw);
  } catch {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(initial));
    return initial.slice();
  }
}

function saveStorage(items) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

export function listReviews() {
  const items = loadStorage();
  return Promise.resolve(items);
}

export function getReview(id) {
  const items = loadStorage();
  const r = items.find(x => x.id === id);
  return Promise.resolve(r || null);
}

export function createReview(data) {
  const items = loadStorage();
  const id = String(Date.now() + Math.floor(Math.random()*900));
  const item = { id, date: new Date().toISOString().slice(0,10), ...data };
  items.unshift(item);
  saveStorage(items);
  return Promise.resolve(item);
}

export function updateReview(id, data) {
  const items = loadStorage();
  const idx = items.findIndex(x => x.id === id);
  if (idx === -1) return Promise.reject(new Error('Not found'));
  items[idx] = { ...items[idx], ...data };
  saveStorage(items);
  return Promise.resolve(items[idx]);
}

export function deleteReview(id) {
  const items = loadStorage();
  const filtered = items.filter(x => x.id !== id);
  saveStorage(filtered);
  return Promise.resolve(true);
}
